let instance = false

export function initTooltipDelegation() {
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.tooltip || instance)
    return

  window.jQuery(document.body).tooltip({
    // Scoped to the icon-only single-value inner span that already has `title`
    selector: '.rails_select__icon-only-single-value .rails_select--option[title]',
    trigger: 'hover focus',
    container: '.app-layout-container',
    delay: {show: 100, hide: 50},
  })

  instance = true

  window.addEventListener('turbo:before-render', hideActiveTooltip)
  window.addEventListener('turbo:before-cache', hideActiveTooltip)
}

export function hideActiveTooltip() {
  if (!window.jQuery || !window.jQuery.fn || !window.jQuery.fn.tooltip)
    return
  try {
    window.jQuery('.rails_select__icon-only-single-value .rails_select--option[title]').tooltip('hide')
  } catch (e) { /* ignore */ }
}

export function disposeTooltipDelegation() {
  if (!instance || !window.jQuery || !window.jQuery.fn || !window.jQuery.fn.tooltip)
    return
  try {
    window.jQuery(document.body).tooltip('dispose')
    instance = false
    window.removeEventListener('turbo:before-render', hideActiveTooltip)
    window.removeEventListener('turbo:before-cache', hideActiveTooltip)
  } catch (e) { /* ignore */ }
}
